import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { useRecoilState } from 'recoil';
import messages from '../static/locales/default.json';
import PageNotFound from './PageNotFound';
import HeaderBar from '../components/Layout/HeaderBar';
import Footer from '../components/Layout/Footer';
import ScreenSwitcher from '../components/ScreenSwitcher';
import { fetchStaticToken } from '../helpers/authentication';
import { domainTheme } from '../config/config';
import { selectedDayjsState } from '../state/selected';

const App = (props) => {
  const {
    match,
    item,
  } = props;

  const [
    selectedDayjs, setSelectedDayjs,
  ] = useRecoilState(selectedDayjsState);

  const theme = domainTheme(window.location.hostname);
  const [translations, setTranslations] = useState(messages);

  useEffect(() => {
    dayjs.locale(item);
    // TODO: see why changing locale globally not working
    setSelectedDayjs(dayjs(selectedDayjs)
      .locale(item));
  }, [item]);

  useEffect(async () => {
    // Add locale to domainTheme in config when adding a new json file
    if (theme.locale) {
      const localeFileResponse = await fetchStaticToken({
        url: `/static/locales/${theme.locale}.json`,
        method: 'GET',
      });

      if (localeFileResponse.status === 200) {
        const locales = await localeFileResponse.json();
        setTranslations({
          en: {
            ...messages.en,
            ...locales.en,
          },
          fr: {
            ...messages.fr,
            ...locales.fr,
          },
        });
      }
    }
  }, []);

  return (
    <IntlProvider
      locale={item}
      messages={translations[item]}
    >
      <HeaderBar location={window.location} />
      <Switch>
        <Route
          path={`${match.path}/professional/:urlTherapistId`}
          exact
          component={ScreenSwitcher}
        />
        <Route
          path={`${match.path}/professionnel/:urlTherapistId`}
          exact
          component={ScreenSwitcher}
        />
        <Route
          path={`${match.path}/`}
          exact
          component={ScreenSwitcher}
        />
        <Route component={PageNotFound} />
      </Switch>
      <Footer />
    </IntlProvider>
  );
};

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
  item: PropTypes.string.isRequired,
};

export default App;
